import getSegmentId from './get-segment-id';
export default function hasSegmentFailed(errors, segmentId) {
  return errors.some(function (error) {
    if (!error.labelStack) {
      return false;
    }
    var errorSegmentId = getSegmentId(error.labelStack);
    return errorSegmentId === segmentId;
  });
}